{
  "titles": {
    "repayments": "Aflossingen",
    "extraCostsSpecification": "Extra kosten specificatie",
    "renewalRequest": "Verlengverzoek",
    "loanProcessor": "Ingediende leningen",
    "menu": "Leningen",
    "confirmProcessApprove": "Leningen uitbetalen",
    "confirmProcessReject": "Leningen afwijzen",
    "refreshError": "Inconsistentie in de data",
    "paymentBatchProcessing": "Uitbetalingen worden verwerkt",
    "confirmLoanRenewal": "Lening verlengen?",
    "overview": "Overzicht",
    "defaulting": "Leningen in gebreke",
    "processor": "Ingediende leningen",
    "newAndActiveLoans": "Nieuwe en lopende leningen",
    "totalOutstandingLoans": "Totaal leningen uitstaand",
    "directDebits": "Incasso log",
    "declineReason": "Reden voor afwijzing"
  },
  "fields": {
    "labels": {
      "requestedAt": "Datum van indienen",
      "amount": "Leningbedrag",
      "interestRate": "Tarief per 30 dagen",
      "interestAmount": "Financieringskosten",
      "paymentAmount": "Uitbetaald bedrag",
      "durationInDays": "Looptijd",
      "period": "Periode",
      "referenceNumber": "Referentienummer",
      "startDate": "Startdatum",
      "collectionDate": "Incassodatum",
      "ToBePaid": "Uit te betalen",
      "invoice": "Factuur",
      "previousLoan": "Vorige lening",
      "financeReceiverDisplayName": "Klant",
      "overdueAmount": "Bedrag in gebreke",
      "defaultingDays": "Achterstand",
      "paymentRemindersSent": "Herinnering",
      "lastPaymentReminderSentAt": "Laatste herinnering",
      "extraCostsSpecification": {
        "defaultingSince": "In gebreke sinds",
        "defaultingDays": "Aantal dagen in gebreke",
        "defaultingAmount": "Bedrag in gebreke",
        "penaltyRate": "Boetetarief",
        "penaltyAmount": "Achterstallige rente",
        "administrationCosts": "Administratiekosten",
        "defaultingAdministrationCosts": "Herinneringen",
        "renewalAdministrationCosts": "Verlenging",
        "partialManualTransferAdministrationCosts": "Handmatige overboekingen",
        "totalAmountToReceive": "Totaal terug te betalen"
      },
      "legacyExtraPrincipalCosts": "Extra financieringskosten",
      "renewalCostsSpecification": {
        "interestAmount": "Financieringskosten",
        "interestAmountIncrease": "Verschil tarief",
        "penaltyAmount": "Achterstallige rente",
        "administrationCosts": "Administratiekosten",
        "defaultingAdministrationCosts": "Herinneringen",
        "renewalAdministrationCosts": "Verlenging",
        "partialManualTransferAdministrationCosts": "Handmatige overboekingen",
        "totalAmountToReceive": "Totaal te ontvangen"
      },
      "reason": "Reden",
      "explanation": "Toelichting",
      "totalOutstandingAmount": "Totaal uitstaand en uitbetaald",
      "totalRequestedAmount": "Totaal ingediend",
      "totalDefaultingAmount": "Totaal in gebreke"
    },
    "values": {
      "monthsSinceLastLoan": {
        "none": "Geen uitbetaalde leningen bekend",
        "zero": "Minder dan een maand geleden",
        "single": "maand",
        "plural": "maanden"
      }
    }
  },
  "headers": {
    "labels": {
      "status": "Status"
    }
  },
  "messages": {
    "collectionDateUpcoming": "Over {time} wordt deze lening geïncasseerd",
    "collectionDateToday": "Vandaag wordt deze lening geïncasseerd",
    "hasPendingRenewalRequest": "Verzoek tot verlengen ontvangen",
    "hasApprovedRenewalRequest": "Verzoek tot verlengen geaccepteerd, betaalinstructies verzonden naar de klant",
    "acceptedPendingRenewalRequest": "Verzoek tot verlengen is geaccepteerd.",
    "expiredRenewalRequest": "Verlengverzoek is verlopen.",
    "renewalUpcoming": "Lening wordt automatisch verlengd per incassodatum",
    "hasRequestedEarlyRepayment": "Verzoek tot eerder terugbetalen ontvangen.",
    "checks": {
      "revolvingCreditFacility": "Ingediend en opgenomen t.o.v. kredietlimiet",
      "monthsSinceLastLoan": "Maanden sinds vorige lening",
      "revenueRatio": "Omzetverhouding (30 dagen/gem. 12 maanden)",
      "defaultingAmount": "Ingebrekestelling"
    },
    "noLoansToProcess": "Er zijn geen leningen om te verwerken",
    "confirmProcessApprove": "Er worden in totaal {loanCount} leningen met een bedrag van {amount} uitbetaald. \n\r \n\rDeze leningen worden direct verwerkt en zullen daarna automatisch naar Twikey worden verstuurd, dit proces kan even duren. Weet je zeker dat je deze leningen wilt verwerken?",
    "confirmProcessReject": "Er worden in totaal {loanCount} leningen met een bedrag van {amount} geweigerd. ",
    "refreshError": "Tijdens het versturen naar de server is gebleken dat de bedragen zijn gewijzigd. Waarschijnlijk is iemand anders tegelijkertijd bezig geweest met het uitbetalen van de leningen. Wil je de pagina vernieuwen om de laatste gegevens te zien?",
    "paymentBatchApproval": "De taak \"Uitbetalingen accorderen\" staat open. Verwerk de transacties in Twikey. Je kunt intussen leningen blijven beoordelen.",
    "paymentBatchProcessing": "Op dit moment worden er uitbetalingen verwerkt en kun je geen nieuwe betalingen doen. Dit duurt maximaal 15 minuten.",
    "confirmLoanRenewal": "Je gaat de lening verlengen. Bij bevestiging ontvangt de klant een bericht om de financieringskosten, extra rentekosten en administratiekosten over te maken. Zodra deze zijn verwerkt, wordt de lening automatisch afgelost met een nieuwe lening.",
    "directDebitsVisibleOnStart": "De incasso’s worden zichtbaar zodra de lening van start gaat",
    "remindersSent": "Herinnering {value}/{max} verzonden",
    "collectionPartiallyFailed": "Incasso's zijn deels mislukt",
    "collectionFullyFailed": "Incasso's zijn mislukt",
    "noRepayments": "Er zijn nog geen aflossingen voor deze lening",
    "emptyStateDescription": "De incasso's worden aangemaakt. Zodra dit succesvol is, zullen ze hier worden getoond.",
    "declinedBy": "De lening is afgewezen door {declinedBy}",
    "hasPausedExtraCost": "Vanwege de migratie zijn de extra kosten voor deze lening gepauzeerd. Je kunt deze hervatten op de detailpagina van de lening.",
    "revalidateDirectDebitsStarted": "De hercontrole van de incasso's is gestart."
  },
  "paymentReminders": {
    "titles": {
      "reminders": "Herinneringen",
      "reminderSent": "{number}e herinnering verzonden",
      "messageBoxTitle": "Bericht verzonden aan klant"
    },
    "messages": {
      "readSendReminder": "Lees verzonden herinnering"
    }
  },
  "actions": {
    "addTransfer": "Betaling toevoegen",
    "approveRenewalRequest": "Betaalinstructies verzenden",
    "renewDefaultingLoan": "Lening verlengen",
    "rejectRenewalRequest": "Afwijzen",
    "reject": "Afwijzen",
    "approve": "Goedkeuren",
    "hold": "On hold",
    "reassess": "Herbeoordelen",
    "approvePaymentBatch": "Uitbetaling accorderen",
    "rejectAll": "Afwijzen",
    "resumeLegacyCalculations": "Hervat in-gebreke berekening"
  },
  "resumeLegacyCalculations": {
    "titles": {
      "dialog": "Hervat in-gebreke berekening"
    },
    "messages": {
      "introduction": "Om alle achterstallige rentes en administratiekosten automatisch te laten berekenen, hebben we eenmalig de huidige stand van deze lening nodig. Pas indien deze zijn ingevuld, gaat het systeem verder met de automatische berekening."
    },
    "fields": {
      "labels": {
        "loanSummary": {
          "referenceNumber": "Referentienummer",
          "amount": "Leningbedrag",
          "collectionDate": "Incassodatum",
          "outstandingAmount": "Totaal nog openstaand"
        },
        "costsAccumulatedUntil": "Datum huidige stand",
        "penaltyAmount": "Hoogte achterstallige rente",
        "administrationCosts": "Hoogte administratiekosten",
        "resumePenalties": "Hervat automatische boeterente berekening per de dag na de peildatum.",
        "resumeDefaultingAdministrationCosts": "Hervat automatische administratiekosten voor herinneringen per de dag na de peildatum.",
        "resumePartialManualTransferAdministrationCosts": "Hervat automatische administratiekosten voor tussentijdse betalingen per de dag na de peildatum."
      }
    },
    "actions": {
      "cancel": "Annuleren",
      "confirm": "Verwerk stand lening"
    },
    "notice": {
      "paused": {
        "title": "In-gebreke berekening is gepauzeerd",
        "description": "Voor deze lening berekenen we momenteel geen:",
        "items": {
          "penalties": "achterstallige rente",
          "defaultingAdministrationCosts": "administratiekosten voor herinneringen",
          "partialManualTransferAdministrationCosts": "administratiekosten voor tussentijdse betalingen"
        }
      },
      "resumed": {
        "titleAll": "In-gebreke berekening mogelijk afwijkend",
        "titlePartial": "In-gebreke berekening is afwijkend",
        "description": "De stand van de lening is per {at} handmatig ingevoerd en kan daarmee afwijken van de standaard berekening.",
        "stillPausedIntro": "Voor deze lening berekenen we momenteel geen:",
        "enteredBy": "In-gebreke stand ingevoerd door {actorName} op {at}"
      }
    }
  }
}
